(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ServiceVendu', ServiceVendu);

    ServiceVendu.$inject = ['$resource'];

    function ServiceVendu ($resource) {
        var resourceUrl =  'api/service-autres/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
